import $axios from './index'

export function getProfit(data) {
    const url = '/api/bi/boss_analysis/get_profit'
    return $axios.get(url, data)
}

export function getSingleUnitSales(data) {
    const url = '/api/bi/boss_analysis/get_single_unit_sales'
    return $axios.get(url, data)
}

export function getAccumulatedProfits(data) {
    const url = '/api/bi/boss_analysis/accumulated_profits'
    return $axios.get(url, data)
}

export function getCompareTrends(data) {
    const url = '/api/bi/boss_analysis/get_compare_trends'
    return $axios.get(url, data)
}